var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUntrackedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 50.3359,
    cy: 50.25,
    r: 50,
    fill: "#686767"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_126452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 26,
    width: 49,
    height: 49
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.6719,
    y: 26.25,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_126452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6719 36.75C47.0915 36.75 43.6577 38.1723 41.1259 40.7041C38.5942 43.2358 37.1719 46.6696 37.1719 50.25C37.1719 53.8304 38.5942 57.2642 41.1259 59.7959C43.6577 62.3277 47.0915 63.75 50.6719 63.75C54.2523 63.75 57.6861 62.3277 60.2178 59.7959C62.7496 57.2642 64.1719 53.8304 64.1719 50.25C64.1719 46.6696 62.7496 43.2358 60.2178 40.7041C57.6861 38.1723 54.2523 36.75 50.6719 36.75ZM32.6719 50.25C32.6719 45.4761 34.5683 40.8977 37.944 37.5221C41.3196 34.1464 45.898 32.25 50.6719 32.25C55.4458 32.25 60.0241 34.1464 63.3998 37.5221C66.7755 40.8977 68.6719 45.4761 68.6719 50.25C68.6719 55.0239 66.7755 59.6023 63.3998 62.9779C60.0241 66.3536 55.4458 68.25 50.6719 68.25C45.898 68.25 41.3196 66.3536 37.944 62.9779C34.5683 59.6023 32.6719 55.0239 32.6719 50.25Z",
    fill: "#F6EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4006 37.5181C63.8224 37.9401 64.0594 38.5123 64.0594 39.1089C64.0594 39.7055 63.8224 40.2777 63.4006 40.6996L41.1256 62.9746C40.7012 63.3845 40.1329 63.6113 39.5429 63.6062C38.953 63.601 38.3887 63.3644 37.9715 62.9472C37.5543 62.5301 37.3177 61.9657 37.3126 61.3758C37.3075 60.7859 37.5342 60.2175 37.9441 59.7931L60.2191 37.5181C60.641 37.0963 61.2132 36.8594 61.8099 36.8594C62.4065 36.8594 62.9787 37.0963 63.4006 37.5181Z",
    fill: "#F6EFE9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntrackedIcon);
export default __webpack_public_path__ + "static/media/untracked_icon.16d67486f06264df8ea8f8135a0ec72e.svg";
export { ForwardRef as ReactComponent };